<template>
  <div class="caf-dashboard container" style="max-width: 85%">
    <loading-spinner v-if="loading" />
    <div v-if="!loading">
      <!-- Info Sede CAF
      <div v-if="!loading && sedeCaf" class="card mt-4">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h2>{{ sedeCaf.nomeSede }}</h2>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h4>Indirizzo</h4>
              <p>
                <strong>Via/Piazza:</strong> {{ sedeCaf.indirizzo }}<br>
                <strong>CAP:</strong> {{ sedeCaf.cap }}<br>
                <strong>Città:</strong> {{ sedeCaf.citta }}<br>
                <strong>Provincia:</strong> {{ sedeCaf.provincia }}
              </p>
            </div>
            <div class="col-md-6">
              <h4>Contatti</h4>
              <p>
                <strong>Telefono:</strong> {{ sedeCaf.telefono }}<br>
                <strong>Email:</strong> {{ sedeCaf.email }}<br>
                <strong>PEC:</strong> {{ sedeCaf.pec }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <b-alert v-if="!loading && !sedeCaf" show variant="warning" class="my-4">
        Nessuna sede CAF associata all'utente.
      </b-alert> -->



      <div v-if="!loading && caf" class="card mt-4">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h2>CAF {{ caf.nominativo }}</h2>
        </div>
      </div>
      <b-alert v-if="!loading && !caf" show variant="warning" class="my-4">
        Nessun CAF associato all'utente.
      </b-alert>

      <!-- Info Utente CAF -->
      <div class="card mt-4">
        <div class="card-header">
          <h2>Utente CAF</h2>
        </div>
        <div class="card-body">
          <div class="text-justify px-4">
            <!-- <template v-if="currentUser.isCafAdmin">
              <label>Admin: </label>
              <b> Si</b>
            </template> -->
            <div class="mt-2">
              <label> Utente:</label>
              <b> {{ currentUser.cognome }} {{ currentUser.nome }}</b>
              <br>
              <label>Codice Fiscale:</label>
              <b> {{currentUser.codiceFiscale}}</b>

            </div>
          </div>
        </div>
      </div>

      <!-- Deleghe CAF -->
      <div class="card mt-3">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h2>Deleghe CAF</h2>
          <div class="d-flex align-items-center gap-2" style="min-width: 0">
            <b-form-input 
              v-model="codiceFiscaleTitolareRicerca" 
              placeholder="CF Titolare" 
              class="mr-2"
              style="width: 200px"
              @input="filtraDeleghe"
            />
            <b-form-input 
              v-model="cfDichiaranteRicerca" 
              placeholder="CF Dichiarante" 
              class="mr-2"
              @input="filtraDeleghe"
            />
            <b-form-input 
              v-model="cfOperatoreRicerca" 
              placeholder="CF Operatore" 
              class="mr-2"
              style="width: 200px"
              @input="filtraDeleghe"
            />
            <b-form-select
              v-model="sedeCafRicerca"
              :options="sediCafOptions"
              placeholder="Filtra per Sede"
              class="mr-2"
              style="width: 200px"
              @change="filtraDeleghe"
            />
            <b-form-select
              v-model="statoRicerca"
              :options="statiOptions"
              class="mr-2"
              style="width: 150px"
              @change="filtraDeleghe"
            />
            <b-button variant="primary" @click="onNuovaDelega">
              <font-awesome-icon icon="plus" class="mr-2"/>Nuova Delega
            </b-button>
          </div>
        </div>
      
        <div class="card-body">
          <loading-spinner v-if="loadingDeleghe" />
          
          <b-alert v-if="!loadingDeleghe && !delegheFiltrate.length" 
                  show variant="info" class="my-4">
            Non ci sono deleghe da visualizzare.
          </b-alert>

          <b-table v-else
            :items="delegheFiltrate"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            striped bordered hover responsive
            >
            
            <!-- Colonna Stato -->
            <template #cell(stato)="data">
              <span :class="getStatoClass(data.item.stato)">
                {{ data.item.stato }}
              </span>
            </template>

            <!-- Colonna Azioni -->
            <template #cell(azioni)="data">
              <div class="d-flex align-items-center text-nowrap">
                <b-button v-if="data.item.stato === 'ATTIVA'"
                        variant="link" 
                        @click.stop="impersonaTitolare(data.item)"
                        title="Accedi come titolare"
                        class="p-1">
                  <font-awesome-icon icon="sign-in-alt" class="text-success"/>
                </b-button>
                
                <b-button v-if="data.item.stato === 'ATTIVA'"
                        variant="link" 
                        @click.stop="revocaDelega(data.item)"
                        title="Revoca delega"
                        class="p-1">
                  <font-awesome-icon icon="sign-out-alt" class="text-danger"/>
                </b-button>
                <b-button v-if="data.item.stato === 'ATTIVA'"
                          variant="link" 
                          @click.stop="chiudiDelega(data.item)"
                          title="Chiudi delega"
                          class="p-1">
                  <font-awesome-icon icon="sign-out-alt" class="text-warning"/>
                </b-button>
              </div>
            </template>
          </b-table>

          <!-- Paginazione -->
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="mr-3">Numero deleghe: {{ delegheFiltrate.length }}</span>

            <b-pagination v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"/>
            
                        
            <b-form-select v-model="perPage" 
                          :options="pageOptions"
                          class="w-auto"/>
          </div>
        </div>

        <nuova-delega-modal 
        ref="nuovaDelegaModal"
        @delega-creata="onDelegaCreata"
      />
      </div>

      <!-- Pratiche CAF -->
      <div class="card mt-4">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h2>Pratiche CAF {{ currentUser.isCafAdmin ? '[Admin]' : '' }}</h2>
          <div class="d-flex align-items-center gap-2" style="min-width: 0">
            
            <b-form-input 
              v-model="cfTitolarePraticaRicerca" 
              placeholder="CF Titolare" 
              class="mr-2"
              style="width: 200px"
              @input="filtraPratiche"
            />
            <b-form-input 
              v-model="cfDichiarantePraticaRicerca" 
              placeholder="CF Dichiarante" 
              class="mr-2"
              @input="filtraPratiche"
            />
            <b-form-input 
              v-model="cfOperatorePraticaRicerca" 
              placeholder="CF Operatore" 
              class="mr-2"
              style="width: 200px"
              @input="filtraPratiche"
            />
            <b-form-select
              v-model="sedeCafPraticaRicerca"
              :options="sediCafOptions"
              placeholder="Filtra per Sede"
              class="mr-2"
              style="width: 200px"
              @change="filtraPratiche"
            />
            <b-form-select
              v-model="statoPraticaRicerca"
              :options="statiPraticaOptions"
              class="mr-2"
              style="width: 150px"
              @change="filtraPratiche"
            />
          </div>
        </div>
      
      
        <div class="card-body">
          <loading-spinner v-if="loadingPratiche" />
          
          <b-alert v-if="!loadingPratiche && !praticheFiltrate.length" 
                  show variant="info" class="my-4">
            Non ci sono pratiche da visualizzare.
          </b-alert>

          <b-table v-else
            :items="praticheFiltrate"
            :fields="praticheCafFields"
            :per-page="perPagePratiche"
            :current-page="currentPagePratiche"
            striped bordered hover responsive
          >
            <template #cell(stato)="data">
              <span :class="{
                'text-primary': data.item.stato === 'B',
                'text-info': data.item.stato === 'P',
                'text-warning': data.item.stato === 'C', 
                'text-success': data.item.stato === 'V'
              }">
                {{ getStatoDescrizione(data.item.stato) }}
              </span>
            </template>
          </b-table>

          <!-- Paginazione -->
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="mr-3">Numero pratiche: {{ praticheFiltrate.length }}</span>

            <b-pagination v-model="currentPagePratiche"
                        :total-rows="totalRowsPratiche"
                        :per-page="perPagePratiche"/>
            
                        
            <b-form-select v-model="perPagePratiche" 
                          :options="pageOptions"
                          class="w-auto"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '@/components/LoadingSpinner'
import NuovaDelegaModal from '@/components/NuovaDelegaModal'
import moment from 'moment'

export default {
  name: 'CafDashboard',
  components: {
    LoadingSpinner,
    NuovaDelegaModal
  },
  data() {
    return {
      loading: true,
      caf: null,
      pageOptions: [5, 10, 25],

      //deleghe
      deleghe: [],
      delegheFiltrate: [],
      loadingDeleghe: true,
      fields: [
        { key: 'codiceFiscaleTitolare', label: 'CF Titolare' },
        { key: 'codiceRu', label: 'RU' },
        { key: 'codiceBu', label: 'BU' },
        { key: 'anniDichiarazione', label: 'Anni Dichiarazione',
          formatter: (value) => value ? value.split(',').join(', ') : '-'
        },
        { key: 'sedeCaf', label: 'Sede CAF' },
        { key: 'cfDichiarante', label: 'CF Dichiarante' },
        { key: 'cfCreatoDa', label: 'CF Operatore' },
        { key: 'stato', label: 'Stato' },
        { key: 'tsCreazione', label: 'Creazione',
          formatter: (value) => moment(value).format('DD/MM/YYYY')
        },
        { key: 'azioni', label: 'Azioni' }
      ],
      sediCafOptions: [
        { value: '', text: 'Tutte le sedi' }
      ],
      // deleghe - ricerca
      codiceFiscaleTitolareRicerca: '',
      statoRicerca: '', // nuovo campo per il filtro stato
      statiOptions: [ // opzioni per la select
        { value: '', text: 'Tutti gli stati' },
        { value: 'ATTIVA', text: 'Attiva' },
        { value: 'CHIUSA', text: 'Chiusa' },
        { value: 'REVOCATA', text: 'Revocata' }
      ],
      sedeCafRicerca: '',
      cfDichiaranteRicerca: '',
      // deleghe - paginazione
      currentPage: 1,
      perPage: 10,
      cfOperatoreRicerca: '', // nuovo campo per il filtro CF operatore deleghe


      // pratiche
      pratiche: [],
      praticheFiltrate: [],
      loadingPratiche: true,
      praticheCafFields: [
        { key: 'cfTitolare', label: 'CF Titolare' },
        { key: 'ru', label: 'RU' },
        { key: 'bu', label: 'BU' },
        { key: 'annoDichiarazione', label: 'Anno' },
        { key: 'sedeCaf', label: 'Sede CAF' },
        { key: 'cfDichiarante', label: 'CF Dichiarante' },
        { 
          key: 'numeroProtocollo', 
          label: 'Protocollo',
          formatter: value => value || '-'
        },
        { key: 'tsUltimaModifica', label: 'Modifica',
          formatter: (value) => moment(value).format('DD/MM/YYYY')
        },
        { key: 'cfOperatore', label: 'CF Operatore' },
        { key: 'stato', label: 'Stato'}
      ],
      statiMap: {
        'B': 'Da confermare',
        'P': 'Precompilata',
        'C': 'In attesa di firma',
        'V': 'Confermato'
      },
      // pratiche - ricerca
      cfOperatorePraticaRicerca: '',
      cfTitolarePraticaRicerca: '',
      statoPraticaRicerca: '',
      statiPraticaOptions: [
        { value: '', text: 'Tutti gli stati' },
        { value: 'B', text: 'Da confermare' },
        { value: 'C', text: 'In attesa di firma' },
        { value: 'V', text: 'Confermato' }
      ],
      sedeCafPraticaRicerca: '',
      cfDichiarantePraticaRicerca: '',
      // pratiche - paginazione
      currentPagePratiche: 1,
      perPagePratiche: 10,
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user || {}
    },
    totalRows() {
      return this.delegheFiltrate.length
    },
    totalRowsPratiche() {
      return this.praticheFiltrate.length
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      try{
        const store = vm.$store
        const user = store.state.auth.user
        const isCafMode = sessionStorage.getItem('cafMode')

        if (!user || !user.isCafUser || !isCafMode) {
          console.log('Accesso non autorizzato alla dashboard CAF')
          next({ name: 'unauthorized' })
        } else {
          console.log('Accesso autorizzato alla dashboard CAF')
          next()
        }
      } catch (err) {
        console.error('Errore nel controllo accesso:', err);
        next({ name: 'unauthorized' });
      }
    })
  },
  async created() {
    try {
      await this.load()
    } catch (err) {
      this.$ui.showError(err)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async load() {
      try {
        // Carica info sede, deleghe e pratiche per tutti gli utenti
        await Promise.all([
          //this.$store.dispatch('caf/info'),
          this.loadCaf(),
          this.loadDeleghe(),
          this.loadPratiche(),
          this.loadSediCaf()
        ]);
        //this.caf = this.$store.state.caf.info;
      } catch (err) {
        this.$ui.showError(err)
      } finally {
        this.loading = false
      }
    },

    async loadSediCaf() {
      try {
        const sedi = await this.$store.dispatch('caf/loadSedi')
        this.sediCafOptions = [
          { value: '', text: 'Tutte le sedi' },
          ...sedi.map(sede => ({
            value: sede.idSede,  
            text: sede.nomeSede
          }))
        ]
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async loadCaf() {
      try {
        await this.$store.dispatch('caf/info')
        this.caf = this.$store.state.caf.info;
      } catch (err) {
        this.$ui.showError(err)
      } 
    },

    async loadPratiche() {
      this.loadingPratiche = true
      try {
        await this.$store.dispatch('caf/loadPratiche')
        this.pratiche = this.$store.state.caf.pratiche
        this.praticheFiltrate = [...this.pratiche]
      } catch (err) {
        this.$ui.showError(err)
      } finally {
        this.loadingPratiche = false
      }
    },

    getStatoDescrizione(stato) {
      return this.statiMap[stato] || stato 
    },

    async loadDeleghe() {
      this.loadingDeleghe = true
      try {
        // Chiama action dello store per caricare le deleghe
        await this.$store.dispatch('caf/loadDeleghe')
        this.deleghe = this.$store.state.caf.deleghe
        this.delegheFiltrate = [...this.deleghe]
      } catch (err) {
        this.$ui.showError(err)
      } finally {
        this.loadingDeleghe = false
      }
    },

    filtraDeleghe() {
      let risultatoFiltrato = [...this.deleghe]

      // Filtro per CF operatore se presente (solo per admin)
      if (this.cfOperatoreRicerca) {
        const queryOperatore = this.cfOperatoreRicerca.toLowerCase()
        risultatoFiltrato = risultatoFiltrato.filter(delega => 
          delega.cfCreatoDa && 
          delega.cfCreatoDa.toLowerCase().includes(queryOperatore)
        )
      }

      // Filtro per CF titolare se presente
      if (this.codiceFiscaleTitolareRicerca) {
        const queryNormalizzata = this.codiceFiscaleTitolareRicerca.toLowerCase()
        risultatoFiltrato = risultatoFiltrato.filter(delega => 
          delega.codiceFiscaleTitolare && 
          delega.codiceFiscaleTitolare.toLowerCase().includes(queryNormalizzata)
        )
      }

      // Filtro per stato se selezionato
      if (this.statoRicerca) {
        risultatoFiltrato = risultatoFiltrato.filter(delega =>
          delega.stato === this.statoRicerca
        )
      }

      // Aggiungi il filtro per CF Dichiarante
      if (this.cfDichiaranteRicerca) {
        risultatoFiltrato = risultatoFiltrato.filter(delega => 
          delega.cfDichiarante &&
          delega.cfDichiarante.toLowerCase().includes(this.cfDichiaranteRicerca.toLowerCase())
        )
      }

      // Filtro per sede CAF se selezionato
      if (this.sedeCafRicerca) {
        risultatoFiltrato = risultatoFiltrato.filter(delega =>
          delega.idSedeCaf === this.sedeCafRicerca
        )
      }

      // Aggiorna le deleghe filtrate
      this.delegheFiltrate = risultatoFiltrato
      
      // Reset alla prima pagina
      this.currentPage = 1
    },

    filtraPratiche() {
      let risultatoFiltrato = [...this.pratiche]
  
      // Filtro per CF operatore se presente (solo per admin)
      if (this.cfOperatorePraticaRicerca) {
        const queryOperatore = this.cfOperatorePraticaRicerca.toLowerCase()
        risultatoFiltrato = risultatoFiltrato.filter(pratica => 
          pratica.cfOperatore && 
          pratica.cfOperatore.toLowerCase().includes(queryOperatore)
        )
      }

      // Filtro per CF titolare
      if (this.cfTitolarePraticaRicerca) {
        const queryTitolare = this.cfTitolarePraticaRicerca.toLowerCase()
        risultatoFiltrato = risultatoFiltrato.filter(pratica => 
          pratica.cfTitolare && 
          pratica.cfTitolare.toLowerCase().includes(queryTitolare)
        )
      }

      // Filtro per stato se selezionato
      if (this.statoPraticaRicerca) {
        risultatoFiltrato = risultatoFiltrato.filter(pratica =>
          pratica.stato === this.statoPraticaRicerca
        )
      }

      // Aggiungi il filtro per CF Dichiarante
      if (this.cfDichiarantePraticaRicerca) {
        risultatoFiltrato = risultatoFiltrato.filter(pratica => 
          pratica.cfDichiarante &&
          pratica.cfDichiarante.toLowerCase().includes(this.cfDichiarantePraticaRicerca.toLowerCase())
        )
      }

      // Filtro per sede CAF se selezionato
      if (this.sedeCafPraticaRicerca) {
        risultatoFiltrato = risultatoFiltrato.filter(pratica =>
          pratica.idSedeCaf === this.sedeCafPraticaRicerca
        )
      }

      // Aggiorna le pratiche filtrate
      this.praticheFiltrate = risultatoFiltrato
      
      // Reset alla prima pagina
      this.currentPagePratiche = 1
    },

    revocaDelega(delega) {
      this.$ui.notify({
        type: 'confirm',
        title: 'Conferma Revoca',
        message: 'Sei sicuro di voler revocare questa delega?',
        okHandler: () => this.confermaRevoca(delega)
      })
    },
    async confermaRevoca(delega) {
      try {
        await this.$store.dispatch('caf/revocaDelega', delega.id)
        await this.loadDeleghe()
        this.$ui.notify({
          type: 'success',
          message: 'Delega revocata con successo'
        })
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    chiudiDelega(delega) {
      this.$ui.notify({
        type: 'confirm',
        title: 'Conferma Chiusura',
        message: 'Sei sicuro di voler chiudere questa delega?',
        okHandler: () => this.confermaChiusura(delega)
      })
    },
    
    async confermaChiusura(delega) {
      try {
        await this.$store.dispatch('caf/chiudiDelega', delega.id)
        await this.loadDeleghe()
        this.$ui.notify({
          type: 'success',
          message: 'Delega chiusa con successo'
        })
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    getStatoClass(stato) {
      const classes = {
        'ATTIVA': 'text-success',
        'IN_USO': 'text-warning',
        'CHIUSA': 'text-secondary',
        'REVOCATA': 'text-danger'
      }
      return classes[stato] || ''
    },

    onNuovaDelega() {
      this.$refs.nuovaDelegaModal.show()
    },

    async onDelegaCreata() {
      await this.loadDeleghe()
    },

    async impersonaTitolare(delega) {
      try {

        // Chiamata allo store per l'impersonificazione
        await this.$store.dispatch('caf/impersonaTitolare', {idDelega: delega.id});

        await this.$store.dispatch('info')

        // Redirect alla home
        this.$router.push({ name: 'home' });

        // return rs.data
      } catch (err) {
        throw err
      }
    }
  }
}
</script>

<style>
.caf-dashboard .card-header h2 {
  font-size: 1.4rem;  /* titoli più piccoli */
}

.caf-dashboard .table {
  font-size: 0.875rem;  /* font più piccolo per le tabelle */
}

.caf-dashboard .form-control,
.caf-dashboard .custom-select {  /* aggiungi questo per i select */
  font-size: 0.8rem;
  width: 155px !important;  /* riduci la larghezza */
}

.caf-dashboard .btn {
  font-size: 0.875rem;  /* font più piccolo per i bottoni */
}
</style>